export default __webpack_public_path__ + "static/speak-emoji-8dd21ae1b5f0444588e807f0ec899401.png";